import React from 'react';
import { Helmet } from 'react-helmet';

const Head = ({ title }) => {
  return (
    <div>
      {/* Helmet for SEO */}
      <Helmet>
        <title>{title}</title>
      </Helmet>
    </div>
  );
};

export default Head;
